
  export default {
    props: {
      error: { type: Object, required: true }
    },

    data () {
      return {
        ctas: {
          energy: '/compare-gas-electricity-prices/',
          broadband: '/compare-tv-broadband-phone/',
          insurance: '/compare-insurance/',
          banking: '/money/'
        }
      };
    }
  };
